




























import { OWebAccountRecovery } from "oweb";
import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component } from "vue-property-decorator";

@Component
export default class WUserAccountRecoveryThree extends BaseComponent {
	form = getForm();

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			o = new OWebAccountRecovery(app);

		o.onError(function(response) {
			app.view.dialog(response);
		})
			.onSuccess(function(response) {
				app.user.setCurrentUser(response.data);

				app.router.forceNextReplace().browseTo("/");
			})
			.stepEnd(form);
	}
}

const getForm = function() {
	return {
		fields: {
			pass: {
				field: "input",
				label: { i18n: "OO_LANG_NEW_PASSWORD" },
				attrs: { name: "pass", type: "password" }
			},
			vpass: {
				field: "input",
				label: { i18n: "OO_LANG_CONFIRM_NEW_PASSWORD" },
				attrs: { name: "vpass", type: "password" }
			},
			submit: {
				field: "submit",
				i18n: "OO_LANG_VALIDATE_BTN"
			}
		}
	};
};
